import { render, staticRenderFns } from "./VxInput.vue?vue&type=template&id=6aab89ca&scoped=true&"
import script from "./VxInput.vue?vue&type=script&lang=js&"
export * from "./VxInput.vue?vue&type=script&lang=js&"
import style0 from "./VxInput.vue?vue&type=style&index=0&id=6aab89ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aab89ca",
  null
  
)

export default component.exports